import doFetch from "scripts/data_utils/doFetch";
export default function formDataFetch(url, data = {}, method = "POST") {
  const formData = new FormData();
  Object.keys(data).map(name => {
    if (Array.isArray(data[name])) {
      data[name].map(el => {
        formData.append(name, el);
      });
    } else {
      formData.append(name, data[name]);
    }
  });
  const options = {
    method,
    body: formData
  };
  return doFetch(url, options);
}